import React from "react";

const localAffiliations = [
  "Federation of Lesotho Trade Union (FELETU)",
  "Coalition of Lesotho Public Employers (COLEPE)",
];

const internationalAffiliations = [
  <a
    key="icn"
    href="https://www.icn.ch/international-council-nurses"
    target="_blank"
    rel="noopener noreferrer"
    className="link-item"
  >
    International Council of Nurses (ICN)
  </a>,
  "African Nurses and Midwives Confederation (ANMC)",
  "Southern Africa Nurses and Midwives Movement (SANNAM)",
];

const partners = [
  <a
    key="leboha"
    href="https://leboha.org.ls/"
    target="_blank"
    rel="noopener noreferrer"
    className="link-item"
  >
    LEBOHA
  </a>,
  "National University of Lesotho (NUL) - Department of Nursing",
  "JHAPIEGO",
  "Lesotho Nursing Council (LNC)",
];

const Affiliation = () => {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.mainTitle}>Our Affiliations & Partners</h1>
        <p style={styles.subtitle}>
          Building strong relationships with local and international organizations 
          to advance nursing excellence in Lesotho
        </p>
      </div>

      <section style={styles.section}>
        <div style={styles.sectionHeader}>
          <div style={styles.iconWrapper}>
            <span style={styles.icon}>🏛️</span>
          </div>
          <h2 style={styles.sectionTitle}>Local Affiliations</h2>
        </div>
        <ul style={styles.list}>
          {localAffiliations.map((name, index) => (
            <li key={index} style={styles.card}>
              <div style={styles.cardContent}>
                {name}
              </div>
            </li>
          ))}
        </ul>
      </section>

      <section style={styles.section}>
        <div style={styles.sectionHeader}>
          <div style={styles.iconWrapper}>
            <span style={styles.icon}>🌍</span>
          </div>
          <h2 style={styles.sectionTitle}>International Affiliations</h2>
        </div>
        <ul style={styles.list}>
          {internationalAffiliations.map((name, index) => (
            <li key={index} style={styles.card}>
              <div style={styles.cardContent}>
                {name}
              </div>
            </li>
          ))}
        </ul>
      </section>

      <section style={styles.section}>
        <div style={styles.sectionHeader}>
          <div style={styles.iconWrapper}>
            <span style={styles.icon}>🤝</span>
          </div>
          <h2 style={styles.sectionTitle}>Our Partners</h2>
        </div>
        <ul style={styles.list}>
          {partners.map((name, index) => (
            <li key={index} style={styles.card}>
              <div style={styles.cardContent}>
                {name}
              </div>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

const styles = {
  container: {
    padding: "2rem 1rem",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundColor: "#f8fafc",
    color: "#2d3748",
    maxWidth: "1200px",
    margin: "0 auto",
    minHeight: "100vh",
  },
  header: {
    textAlign: "center",
    marginBottom: "3rem",
    padding: "2rem 1rem",
    background: "linear-gradient(135deg, #001f54 0%, #034078 100%)",
    borderRadius: "12px",
    color: "white",
  },
  mainTitle: {
    fontSize: "2.8rem",
    marginBottom: "1rem",
    fontWeight: "700",
    letterSpacing: "-0.5px",
  },
  subtitle: {
    fontSize: "1.2rem",
    opacity: "0.9",
    maxWidth: "600px",
    margin: "0 auto",
    lineHeight: "1.6",
    fontWeight: "300",
  },
  section: {
    marginBottom: "3rem",
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "2rem",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
    border: "1px solid #e2e8f0",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1.5rem",
    paddingBottom: "1rem",
    borderBottom: "2px solid #f1f5f9",
  },
  iconWrapper: {
    backgroundColor: "#001f54",
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "1rem",
  },
  icon: {
    fontSize: "1.5rem",
  },
  sectionTitle: {
    fontSize: "1.8rem",
    color: "#001f54",
    fontWeight: "600",
    margin: 0,
  },
  list: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: "1.5rem",
    padding: 0,
    listStyle: "none",
  },
  card: {
    backgroundColor: "#fff",
    padding: "0",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0, 31, 84, 0.1)",
    transition: "all 0.3s ease",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
  },
  cardContent: {
    padding: "1.5rem",
    textAlign: "center",
    fontSize: "1rem",
    fontWeight: "500",
    minHeight: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

// Add CSS for link hover effects
const linkStyles = `
  .link-item {
    color: #001f54;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    display: inline-block;
  }
  
  .link-item:hover {
    color: #034078;
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    .link-item:hover {
      transform: none;
    }
  }
`;

// Inject styles
const styleSheet = document.styleSheets[0];
if (styleSheet) {
  const styleElement = document.createElement('style');
  styleElement.textContent = linkStyles;
  document.head.appendChild(styleElement);
}

export default Affiliation;